<template>
  <v-card flat class="my-0">
    <v-card-text>
      <v-text-field
        v-model="field.maxLength"
        type="number"
        v-bind:label="$t('MaximumLongitude')"
        :error-messages="maxLengthErrors"
        @input="validator.field.maxLength.$touch()"
        @blur="validator.field.maxLength.$touch()"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
      <v-text-field
        v-model="field.default"
        v-bind:label="$t('DefaultValue')"
        @change="applyDefaultValueRestrictions"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    maxLengthErrors() {
      const errors = [];
      if (!this.validator.field.maxLength.$dirty) return errors;
      !this.validator.field.maxLength.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    applyDefaultValueRestrictions() {
      if (!this.field.default) {
        return;
      }
      if (this.field.maxLength)
        this.field.default = this.field.default.substring(
          0,
          this.field.maxLength - 1
        );
    },
  },
};
</script>